import { render, staticRenderFns } from "./EDrawerMotivoAulaAEE.vue?vue&type=template&id=48412d66&scoped=true"
import script from "./EDrawerMotivoAulaAEE.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAulaAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48412d66",
  null
  
)

export default component.exports